import { alpha, Box, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAssetsBaseUrl } from '../../../config/assetsUrl';
import Container from '../../../layout/Container';
import AnimatedTypography from '../../core/AnimatedTypography';

const HomeAboutPreviewMobile: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                mt: { xs: 6, md: 8 },
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: 6, md: 8 },
            }}
        >
            {/* Section 1 – AVANTURA POČINJE SADA – isto kao web */}
            <Box
                sx={{
                    position: 'relative',
                    width: '100vw',
                    marginLeft: 'calc(50% - 50vw)',
                    minHeight: { xs: 420, md: 520 },
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    backgroundImage: `url(${getAssetsBaseUrl()}/images/background/landingimage5.jpeg)`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    py: 4
                }}
            >
                <Box
                    sx={(theme) => ({
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: alpha(theme.palette.background.default, 0.82),
                        ...theme.applyStyles('dark', {
                            backgroundColor: alpha(theme.palette.background.default, 0.88),
                        }),
                    })}
                />
                <Container>
                    <Box sx={(theme) => ({ position: 'relative', zIndex: 1, maxWidth: 640, borderLeft: '4px solid', borderColor: '#376ac7', pl: 1.5 })}>
                        <AnimatedTypography variant="h3" mb={2} color="text.primary" fontWeight={700}>
                            {t('abousUs.section1.title')}
                        </AnimatedTypography>
                        <Typography
                            component="p"
                            sx={(theme) => ({
                                mb: 2.5,
                                fontWeight: 700,
                                fontSize: { xs: '1.1rem', sm: '1.25rem' },
                                lineHeight: 1.4,
                                color: "#f6cccc",
                                letterSpacing: '0.02em',
                                pl: 1.5,
                                py: 1,
                                borderLeft: '3px solid',
                                borderColor: 'primary.main',
                                bgcolor: alpha(theme.palette.primary.main, 0.1),
                                borderRadius: '0 8px 8px 0',
                            })}
                        >
                            {t('abousUs.section1.experienceTagline')}
                        </Typography>
                        {[1, 2, 3, 4, 5, 6].map((i) => {
                            const text = t(`abousUs.section1.${i}`);
                            if (!text) return null;
                            return (
                                <Typography key={i} color="text.primary" mb={2}>
                                    {text}
                                </Typography>
                            );
                        })}
                    </Box>
                </Container>
            </Box>

            {/* Section 3 – isto kao web */}
            <Box
                sx={{
                    position: 'relative',
                    width: '100vw',
                    marginLeft: 'calc(50% - 50vw)',
                    minHeight: { xs: 420, md: 520 },
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    backgroundImage: `url(${getAssetsBaseUrl()}/images/background/landingimage4.jpeg)`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    py: 4
                }}
            >
                <Box
                    sx={(theme) => ({
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: alpha(theme.palette.background.default, 0.82),
                        ...theme.applyStyles('dark', {
                            backgroundColor: alpha(theme.palette.background.default, 0.88),
                        }),
                    })}
                />
                <Container>
                    <Box sx={(theme) => ({ position: 'relative', zIndex: 1, maxWidth: 640, ml: { xs: 0, md: 'auto' }, borderLeft: '4px solid', borderColor: '#376ac7', pl: 1.5 })}>
                        <AnimatedTypography variant="h3" mb={2} color="text.primary" fontWeight={700}>
                            {t('abousUs.section3.title')}
                        </AnimatedTypography>
                        <Typography color="text.primary" mb={2}>
                            {t('abousUs.section3.1')}
                        </Typography>
                        <Typography color="text.primary" mb={2}>
                            {t('abousUs.section3.2')}
                        </Typography>
                        <Trans
                            i18nKey="abousUs.section3.3"
                            components={{
                                highlight: (
                                    <Typography
                                        component="span"
                                        color="text.primary"
                                    />
                                )
                            }}
                        />
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default HomeAboutPreviewMobile;
